import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Supplier`;
const baseServiceUrlFileManager = `/api/v1/FileManager`;
const env = process.env;



const ApiSupplier = {
  getAllSupplier: (params) => {
    const url = `${baseServiceUrl}/getAllSupplier`;
    return ServiceApi.get(url, { params });
  },
  getAllSuppliersName: () => {
    const url = `${baseServiceUrl}/getAllSuppliersName`;
    return ServiceApi.get(url);
  },
  getAllUsedPromoCodeByUser: (params) => {
    const url = `${baseServiceUrl}/getAllUsedPromoCodeByUser`;
    return ServiceApi.get(url, { params });
  },
  getSupplierById: (params) => {
    const url = `${baseServiceUrl}/getSupplierById?id=` + params;
    return ServiceApi.get(url);
  },
  getSupplierApprovalStatus: () => {
    const url = `${baseServiceUrl}/getSupplierApprovalStatus`;
    return ServiceApi.get(url);
  },
  createAgency: (params) => {
    const url = `${baseServiceUrl}/createAgency`;
    return ServiceApi.post(url, params);
  },
  updateSupplier: (params) => {
    const url = `${baseServiceUrl}/updateSupplier`;
    return ServiceApi.put(url, params);
  },
  getFile: (params) => {
    const url = `${baseServiceUrl}/getFile`;
    return ServiceApi.get(url, { params: params, baseURL: env.REACT_APP_PHOTOPATH_Supplier, responseType: 'blob' });

  },
  getFileOfFileManager: (params) => {
    const url = `${baseServiceUrlFileManager}/getFile`;
    return ServiceApi.get(url, { params: params, baseURL: env.REACT_APP_PHOTOPATH_Supplier, responseType: 'blob' });

  },
  createSupplier: (params) => {
    const url = `${baseServiceUrl}/createSupplier`;
    return ServiceApi.put(url, params);

  },
  getAllSuppliersBalances: () => {
    const url = `${baseServiceUrl}/getAllSuppliersBalances`;
    return ServiceApi.get(url);
  },
  updateSupplierUser: (params) => {
    const url = `${baseServiceUrl}/updateSupplierUser`;
    return ServiceApi.put(url, params);
  },
  getSupplierUserById: (params) => {
    const url = `${baseServiceUrl}/getSupplierUserById?id=${params.id}`;
    return ServiceApi.get(url, params);
  },
  getSupplierExcel: (params) => {
    const url = `${baseServiceUrl}/GetAllSupplierByExcel`;
    return ServiceApi.get(url, { params: params, responseType: 'blob' });
  }
};

export default ApiSupplier;


